import { Alert } from '@ksyos/design-system';

export function CaroActivatedAccountAlert(props: { hasActivatedAccount: boolean }) {
    return (
        <Alert
            appearance={props.hasActivatedAccount ? 'success' : 'warning'}
            hasIcon={true}
        >
            {props.hasActivatedAccount
                ? 'Patiënt heeft ingelogd in de Ksyos app'
                : 'Patiënt heeft niet ingelogd in de Ksyos app'}
        </Alert>
    );
}
